/**
 * Секция акций на странице клиники.
 *
 * На мобилке без списка акций блок не рендерится даже для staff —
 * пустой заголовок для модерации есть только на десктопе.
 */
export default function isLpuPromotionsSectionVisible(opts: {
  promotionsLength: number
  isMobile: boolean
  isStaff: boolean
}): boolean {
  if (opts.promotionsLength > 0) {
    return true
  }

  return !opts.isMobile && opts.isStaff
}
